import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { Budget, BudgetDetail, BudgetCreate, BudgetUpdate } from '@core/types/finance.type';
import { PaginationResult, PaginationConfig } from './unit.service';
import { buildPaginationBody } from '@core/utils/pagination.util';

@Injectable({ providedIn: 'root' })
export class BudgetService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/finance/budgets`;

  getBudgets(config: PaginationConfig): Observable<ApiResponse<PaginationResult<Budget>>> {
    return this.http.post<ApiResponse<PaginationResult<Budget>>>(`${this.apiUrl}/grid`, buildPaginationBody(config));
  }

  getBudget(id: string): Observable<ApiResponse<BudgetDetail>> {
    return this.http.get<ApiResponse<BudgetDetail>>(`${this.apiUrl}/${id}`);
  }

  createBudget(data: BudgetCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.apiUrl, data);
  }

  updateBudget(data: BudgetUpdate): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(this.apiUrl, data);
  }

  deleteBudget(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }

  approveBudget(id: string): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${id}/approve`, {});
  }
}
